function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/* eslint-disable prefer-template */
import React from 'react';
function DefaultWrapper(_ref) {
  var childProps = _ref.childProps,
    children = _ref.children,
    isFailed = _ref.isFailed,
    isLoaded = _ref.isLoaded,
    props = _objectWithoutProperties(_ref, ['childProps', 'children', 'isFailed', 'isLoaded']);
  var className = 'react-lazy-wrapper' + (!isLoaded && !isFailed ? ' react-lazy-wrapper--' + (childProps ? 'loading' : 'placeholder') : '') + (isFailed ? ' react-lazy-wrapper--failed' : '') + (isLoaded ? ' react-lazy-wrapper--loaded' : '') + (props.className ? ' ' + props.className : '');
  return React.createElement('div', Object.assign({}, props, {
    className: className
  }), children);
}
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default DefaultWrapper;